import { render, staticRenderFns } from "./PartidaBalaEdit.vue?vue&type=template&id=61a032db&scoped=true"
import script from "./PartidaBalaEdit.vue?vue&type=script&lang=js"
export * from "./PartidaBalaEdit.vue?vue&type=script&lang=js"
import style0 from "./PartidaBalaEdit.vue?vue&type=style&index=0&id=61a032db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a032db",
  null
  
)

export default component.exports